<template>
  <v-card class="mx-auto elevation-1 mt-10 pa-8">
    <div class="text-h5 mt-6 mb-6 font-weight-regular text-center">
      {{ $t("EmailVerificationReqMessage") }}
    </div>
    <v-card-text class="pt-4 pb-4">
      <v-alert dense outlined type="error" v-if="error">
        <ul>
          <li v-for="item in error" :key="item.msg">{{ $t(item.msg) }}</li>
        </ul>
      </v-alert>
      <v-form
        ref="form"
        v-model="valid"
        @submit.prevent="submit"
        lazy-validation
      >
        <v-row>
          <v-col cols="12" md="8" class="pb-0 pt-0">
            <v-text-field
              outlined
              type="text"
              v-model="vcode"
              v-bind:label="$t('EnterYourEmailVerificationCode')"
              :rules="reqRules"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4" class="pb-0 pt-0">
            <v-btn
              large
              color="light-blue"
              block
              dark
              x-large
              height="56"
              rounded
              type="submit"
            >
              <span class="mr-2">{{ $t("Verify") }}</span>
              <v-icon size="small">mdi-arrow-right-thick</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <div class="mt-2">
          {{ $t("Cmsg36") }}
          <a @click="sendCode()"> {{ $t("ClickHere") }} </a>
          {{ $t("Cmsg37") }}
        </div>
      </v-form>
      <WaitDialogComponent :waitDialog="waitDialog" />
    </v-card-text>
  </v-card>
</template>

<script>
// @ is an alias to /src
import WaitDialogComponent from "@/components/layout/WaitDialogComponent.vue";
import AuthService from "@/services/AuthService";
import swal from "sweetalert";

export default {
  name: "EmailVerificationComponent",
  components: { WaitDialogComponent },
  data() {
    return {
      waitDialog: false,
      parm: this.$route.params.id,
      vcode: "",
      valid: null,
      error: null,
      reqRules: [value => !!value || this.$t("string719")]
    };
  },
  mounted: function() {
    this.expand = !this.expand;
  },
  methods: {
    async sendCode() {
      this.waitDialog = true;
      await AuthService.sendEmailVerifyCode({
        user_id: this.parm
      })
        .then(result => {
          swal({
            icon: "success",
            text: result.data.message,
            button: {
              text: this.$t("Close"),
              className: "swal-close"
            }
          });
          this.waitDialog = false;
        })
        .catch(err => {
          this.waitDialog = false;
          this.error = err.response.data.errors;
        });
    },
    async submit() {
      await this.$refs.form.validate();
      if (this.valid) {
        this.waitDialog = true;
        await AuthService.verifyEmail({
          emailOtp: this.vcode,
          user_id: this.parm
        })
          .then(result => {
            swal({
              icon: "success",
              text: result.data.msg,
              button: {
                text: this.$t("Close"),
                className: "swal-close"
              }
            });
            this.$router.push({
              name: "Login",
              query: { redirect: this.$route.query.redirect }
            });
            this.waitDialog = false;
          })
          .catch(err => {
            this.waitDialog = false;
            this.error = err.response.data.errors;
          });
      }
    }
  }
};
</script>

<style scoped></style>
